const CaseStudyCard = (props) => {
  return (
    <li className="case-study-card">
      <a href={props.link} rel="noopener noreferrer">
        <img src={props.brand} alt={props.client} />
        <div className="case-content">
          <div className="case-tags center">
            <span className="case-solution">{props.solution}</span> |{" "}
            <span className="case-client">{props.client}</span>
          </div>
          <h3 className="case-title">{props.title}</h3>
          <p className="case-subtitle font-inter-regular">{props.subtitle}</p>
          <ul className="case-scope font-inter-regular">{props.children}</ul>
          <div className="case-cta-container">
            <span className="font-inter-regular">View Details</span>
          </div>
        </div>
      </a>
    </li>
  );
};

export default CaseStudyCard;
